import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  "fill-rule": "evenodd",
  d: "M9 13.714a4.714 4.714 0 1 0 0-9.428 4.714 4.714 0 0 0 0 9.428M9 15A6 6 0 1 0 9 3a6 6 0 0 0 0 12",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#797979",
  d: "m9.849 5-.186 5.39H8.29L8.093 5zm-.837 8q-.443 0-.733-.257A.88.88 0 0 1 8 12.085q0-.39.28-.647a1.04 1.04 0 0 1 .732-.268q.43 0 .709.268.279.257.279.647t-.28.658a1 1 0 0 1-.708.257"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon-warning"}) } }